import { useEffect, useState } from "react";
import { useAuth } from "./login/AuthProvider";
import { Navigate, Outlet} from "react-router-dom";

const ProtectedRoute = () => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  return isAuthenticated ? <Outlet /> : <Navigate to="/" replace />;
};

export const ProtectedRouteWithPermission = ({ element: Component, path }) => {
  const { user, loading } = useAuth();
  const [permittedPaths, setPermittedPaths] = useState([]);
  const [isLoadingPermissions, setIsLoadingPermissions] = useState(true);

  useEffect(() => {
    if (user && user.userId !== 1) {
      fetch(`https://uk.backend.hms.hiradentallab.com/api/page/user/${user.userId}/pages`)
        .then(res => res.json())
        .then(data => {
          const paths = data.map(permission => permission.page.path);
          setPermittedPaths(paths);
          setIsLoadingPermissions(false);
        })
        .catch(err => {
          console.error('Error fetching permissions:', err);
          setIsLoadingPermissions(false);
        });
    } else {
      setIsLoadingPermissions(false); // Admin (userId: 1) skips permission check
    }
  }, [user]);

  if (loading || isLoadingPermissions) {
    return <div>Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/" replace />;
  }

  // Admin (userId: 1) has access to all pages
  if (user.userId === 1) {
    return <Component />;
  }

  // Check if current path is permitted for non-admin users
  const basePath = path.split('/:')[0]; // Handle parameterized routes, e.g., '/case/:caseId' -> '/case'
  const isPermitted = permittedPaths.some(p => 
    p === path || (p.includes('/:') && p.startsWith(basePath))
  );

  if (!isPermitted) {
    return <div>Access Denied</div>;
  }

  return <Component />;
};

export default ProtectedRoute;